import PageContent from "../PageContent/PageContent";
import { useEffect } from "react";

import InfoCover from "../PageContent/PageCovers/InfoCover";
import PropShow from "../PageContent/PropShow";
import BrancoAnim from "../PageContent/BrancoAnim";
import VideoAsk from "../PageContent/VideoAsk";
import VidTestim from "../PageContent/VidTestim";
import Fancy from "../PageContent/Fancy";
import PinkForm from "../PageContent/PinkForm";
import Footer from "../PageContent/Footer";
import CTAButton from "../PageContent/CTAButton";
import Marquee from "../PageContent/Marquee";
import Map from "../PageContent/MapPart";
import QuestionBox from "../PageContent/QuestionBox";
import Testimonial from "../PageContent/Testimonial";


const questionBoxData = {
    title: "DOE JEZELF NIET TE KORT!",
    text: ["Kijk zeker naar onze nieuws en", "video pagina.", "Vol met niet te missen informatie!"],
    button: "IK GA NU KIJKEN!"
}

function Region({ page, title, text }) {
    useEffect(() => {
        document.title = title ? title : page;
    }, [title, page]);

    return (
        <div className="content-ctnr">

            <InfoCover page={page} text={text} />
            <BrancoAnim page={page} text={text} key="first" />
            <VidTestim page={page} text={text} />
            <BrancoAnim page={page} number="2" text={text} key="second"/>
            <QuestionBox data={questionBoxData} marginTop="70px" />
            <Testimonial page={page} text={text} />
            <Footer page={page} text={text} />

            <CTAButton page={page} />
        </div>
    );
}

export default Region;